import Component from '@glimmer/component'
import { service } from '@ember/service'
import { t } from 'ember-intl'
import type SideNavService from 'teacher-ui-client/services/side-nav'
import SideNavItem from 'teacher-ui-client/components/side-nav/item'
import SideNavIconComponent from 'teacher-ui-client/components/side-nav/icon'
import questionMarkUnfilled from '@images/icons/question-mark-unfilled.svg'

export class ContactUsLink extends Component {
  @service sideNav!: SideNavService

  get isVisible() {
    return !this.sideNav.isHomeschool
  }

  <template>
    {{#if this.isVisible}}
      <SideNavItem data-test-side-nav-contact-us @linkTo="subscription-type.contact-us" @overrideDisabled={{true}}>
        <SideNavIconComponent @url={{questionMarkUnfilled}} @alt="Sidenav question" />
        <span>{{t "sideNav.contactUs"}}</span>
      </SideNavItem>
    {{/if}}
  </template>
}

export default ContactUsLink
